/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Picture/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Picture({
  children,
  viewPath = "/DesignSystem/Avatar/Picture",
  alignSelf = "auto",
  borderTopLeftRadius,
  borderTopRightRadius,
  borderBottomLeftRadius,
  borderBottomRightRadius
  
}) {
let avatarProfileUrlValueData = fromData.useDataValue({ viewPath,
context: 'avatar',
path: 'profile_url',
})
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let borderTopLeftRadiusOrdtSpaceL = borderTopLeftRadius ?? dtSpaceL
let borderTopRightRadiusOrdtSpaceL = borderTopRightRadius ?? dtSpaceL
let borderBottomLeftRadiusOrdtSpaceL = borderBottomLeftRadius ?? dtSpaceL
let borderBottomRightRadiusOrdtSpaceL = borderBottomRightRadius ?? dtSpaceL
  return (<React.Fragment
>
<img
  data-testid="Picture.Image"
  data-view-path={viewPath}
 alt={""}
 src={avatarProfileUrlValueData}
 style={{'--as-1-1huy2K': alignSelf,'--btlr-2-1huy2K': typeof borderTopLeftRadiusOrdtSpaceL === 'number' ? `${borderTopLeftRadiusOrdtSpaceL}px` : borderTopLeftRadiusOrdtSpaceL,'--btrr-3-1huy2K': typeof borderTopRightRadiusOrdtSpaceL === 'number' ? `${borderTopRightRadiusOrdtSpaceL}px` : borderTopRightRadiusOrdtSpaceL,'--bblr-4-1huy2K': typeof borderBottomLeftRadiusOrdtSpaceL === 'number' ? `${borderBottomLeftRadiusOrdtSpaceL}px` : borderBottomLeftRadiusOrdtSpaceL,'--bbrr-5-1huy2K': typeof borderBottomRightRadiusOrdtSpaceL === 'number' ? `${borderBottomRightRadiusOrdtSpaceL}px` : borderBottomRightRadiusOrdtSpaceL}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}